import Utils from '../../utils/Utils';
import settings from '../../devices/all/settings';
import logger from 'src/utils/logger/logger';

class EventManager {
  /**
   *Creates an instance of EventManager.
   * @param {*} controllers  Conjunto de controladores a donde se le enviara el key y actuaran acorde a cada keyHandler
   * @memberof EventManager
   */
  constructor(controllers) {
    this.controllers = controllers;
    this.recentKeyPress = null;
    this.keyTimeoutId = null;
    this.keyHandler = this.keyHandler.bind(this);
    this.setOutside = this.setOutside.bind(this);
    this.setHandleMosaic = this.setHandleMosaic.bind(this);
    this.setHandleRed = this.setHandleRed.bind(this);
    this.setHandleBlue = this.setHandleBlue.bind(this);
    this.last_repeat = false;
    this.last_key = '';
    this.epgOutside = null;
    this.handleMosaic = null;
    this.handleGuide = null;
    this.handleRed = null;
    this.handleBlue = null;

    this.handleClearTimeoutAutoHide = null;
    this.handleSetAutoHideTimeout = null;
  }

  setOutside(cb) {
    this.epgOutside = cb;
  }

  setHandleMosaic(cb) {
    this.handleMosaic = cb;
  }

  setHandleGuide(cb) {
    this.handleGuide = cb;
  }

  setHandleRed(cb) {
    this.handleRed = cb;
  }
  setHandleBlue(cb) {
    this.handleBlue =  cb;
  }

  setClearTimeoutAutoHide(cb) {
    this.handleClearTimeoutAutoHide = cb;
  }

  setAutoHideTimeout(cb) {
    this.handleSetAutoHideTimeout = cb;
  }

  /**
   *
   *
   * @param {*} key Nombre de la tecla presionada
   * @param {*} event Evento completo de la tecla presionado
   * @param {boolean} [repeats=false] True si esta en modo desesperado
   * @returns
   * @memberof EventManager
   */
  keyHandler(key, event, repeats = false) {
    if (!Utils.isModalHide() || key == undefined || !key) {
      return;
    }

    if (key === 'BACK') {
      if (this.epgOutside && typeof this.epgOutside == 'function') {
        this.handleClearTimeoutAutoHide();
        this.epgOutside();
        return true;
      }
    } else if (key === 'VOD') {
      if (this.epgOutside && typeof this.epgOutside == 'function') {
        this.handleClearTimeoutAutoHide();
        this.epgOutside();
        return true;
      }
    } else if (key === 'MOSAIC') {
      if (this.handleMosaic && typeof this.handleMosaic == 'function') {
        this.handleClearTimeoutAutoHide();
        this.handleMosaic();
        return true;
      }
    } else if (key === 'GUIDE') {
      if (this.handleGuide && typeof this.handleGuide == 'function') {
        this.handleGuide();
        return true;
      }
    } else if (key === 'RED') {
      if (this.handleRed && typeof this.handleRed == 'function') {
        this.handleRed();
        return true;
      }
    } else if (key === 'BLUE') {
      let currentEvent= this.controllers.eventController.eventFocused;
      if (currentEvent && this.handleBlue && (typeof this.handleBlue === 'function')) {
        this.handleBlue(currentEvent);
        return true;
      }
    }
    if (this.recentKeyPress === key) {
      repeats = true;
      this.last_repeat = repeats;
      this.last_key = key;
    }

    this.recentKeyPress = key;
    clearTimeout(this.keyTimeoutId);
    this.keyTimeoutId = setTimeout(() => {
      this.recentKeyPress = null;
    }, 1000);

    if (key === this.last_key + '_UP') {
      repeats = this.last_repeat;
    }

    // Si quiere cambiar de canal, se cierra la
    if (key === 'OK') {
      logger.debug('[PAU]> Clear timeout con key OK');
      this.handleClearTimeoutAutoHide();
    } else {
      logger.debug('[PAU]> SetAutoHideTimeout keyHandler key: ' + key, 'repeats: ', repeats);
      if (key.indexOf('_UP') === -1 && !repeats) {
        this.handleSetAutoHideTimeout();
      }
    }

    for (const x in this.controllers) {
      if (
        this.controllers[x] &&
        this.controllers[x].keyHandler &&
        typeof this.controllers[x].keyHandler === 'function'
      ) {
        if (this.controllers[x].keyHandler(key, event, repeats)) {
          if (key.indexOf('_UP') !== -1) {
            this.last_repeat = false;
            if (repeats) {
              this.handleSetAutoHideTimeout();
            }
            this.last_key = '';
          }
          break;
        }
      }
    }
    return true;
  }
}
export default EventManager;



// WEBPACK FOOTER //
// ./src/AAF/Nepg/EventManager.js